import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Carousel from 'react-elastic-carousel';
import { useMediaQuery } from 'react-responsive';

import styles from './slider2.module.scss';

const Slider2 = ({ t }) => {
  const data = [
    {
      id: '0',
      title: t('titles.x-soft-job_Trained models'),
      text: t(
        'text.x-soft-job_By processing the language resulting'
      ),
    },
    {
      id: '1',
      title: t('titles.x-soft-job_Automatic posting'),
      text: t(
        'text.x-soft-job_From absorbing this information'
      ),
    },
    {
      id: '2',
      title: t('titles.x-soft-job_Easy catch of applications'),
      text: t(
        'text.x-soft-job_By connecting to the CV reading'
      ),
    },
    {
      id: '3',
      title: t('titles.x-soft-job_Clear Reporting & KPIs'),
      text: t(
        'text.x-soft-job_In order not to miss any of the steps'
      ),
    },
  ];

  const carousel = useRef(null);
  const delay = 3000;

  const shouldGoHorizontal = useMediaQuery({
    query: '(max-width: 1180px)',
  });

  const setCarouselToStart = (currentItem) => {
    if (currentItem.index === 3) {
      setTimeout(() => {
        if (!carousel) return;

        carousel?.current?.goTo(0);
      }, delay);
    }
  };

  return (
    <section className={`slider2 ${styles.section}`}>
      <div className={styles.slidersHeader}>
        {t(
          'text.How to save time by focusing only on the value-added tasks of recruitment?'
        )}
      </div>

      <div className={styles.slider}>
        <Carousel
          verticalMode={!shouldGoHorizontal}
          showArrows={false}
          itemsToShow={1}
          enableSwipe={false}
          enableMouseSwipe={false}
          preventDefaultTouchmoveEvent={true}
          ref={carousel}
          enableAutoPlay
          autoPlaySpeed={delay}
          transitionMs={delay}
          onChange={(currentItem) => {
            setCarouselToStart(currentItem);
          }}
        >
          {data &&
            data.map((item, index) => (
              <div key={item.id} className={`${styles.post} ${styles[`post${index}`]}`}>
                <div className={styles.postsText}>
                  <span className={styles.title}>{item.title}</span>
                  <p className={styles.text}>{item.text}</p>
                </div>
              </div>
            ))}
        </Carousel>
      </div>
    </section>
  );
};

Slider2.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Slider2;
